/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { memo, useContext } from 'react';

import { Slider } from '@mui/material';

import { useCreateClusterFormStyles } from '../../CreateClusterOverlay.styles';
import { createSliderMarks } from '../../utils';
import { ReplicaContext } from './consts';
import { ReplicasProps } from './types';

export const Replicas = memo<ReplicasProps>(({ setFieldValue, values }) => {
  const classes = useCreateClusterFormStyles();

  const {
    state: { replicaMax, replicaMin },
  } = useContext(ReplicaContext);

  const handleChange = (_: any, value: number | number[]) => setFieldValue('replicas', value as number);

  return (
    <>
      <div className={classes.replicasLabel}>Replicas</div>
      <div className={classes.replicasWrapper}>
        <div className={classes.replicasSlider}>
          <Slider
            track={false}
            value={values.replicas}
            onChange={handleChange}
            min={replicaMin}
            max={replicaMax}
            marks={createSliderMarks(replicaMin, replicaMax)}
            data-cy="replicas-slider"
          />
        </div>
      </div>
    </>
  );
});
